export const SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS = {
  CAMPAIGN_SETTINGS: 'CAMPAIGN_SETTINGS',
  KEYWORDS: 'KEYWORDS',
  CREATE_AD: 'CREATE_AD',
  ADD_MORE_ASSETS: 'ADD_MORE_ASSETS',
  BUDGET_AND_BIDS: 'BUDGET_AND_BIDS',
  SUMMARY: 'SUMMARY',
};

export const getCampaignCreationStepListConfig = ({ i18n, showExtensionsStep = false }) => [{
  id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CAMPAIGN_SETTINGS,
  title: i18n.getString(_TL_('Campaign settings')),
}, {
  id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.KEYWORDS,
  title: i18n.getString(_TL_('Keywords')),
}, {
  id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
  title: i18n.getString(_TL_('Create ad')),
  ...showExtensionsStep && {
    steps: [{
      id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
      title: i18n.getString(_TL_('Add text')),
    }, {
      id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.ADD_MORE_ASSETS,
      title: i18n.getString(_TL_('Add more assets')),
    }],
  },
}, {
  id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.BUDGET_AND_BIDS,
  title: i18n.getString(_TL_('Budget & bids')),
}, {
  id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.SUMMARY,
  title: i18n.getString(_TL_('Summary')),
}];

export const getSearchCampaignCreationFlow = (flowFactors) => {
  const { showExtensions = false } = flowFactors;

  if (showExtensions) {
    return [
      SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CAMPAIGN_SETTINGS,
      SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.KEYWORDS,
      SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
      SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.ADD_MORE_ASSETS,
      SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.BUDGET_AND_BIDS,
      SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.SUMMARY,
    ];
  }

  return [
    SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CAMPAIGN_SETTINGS,
    SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.KEYWORDS,
    SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
    SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.BUDGET_AND_BIDS,
    SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.SUMMARY,
  ];
};

export const SEARCH_CAMPAIGN_EDIT_WIZARD_STEP_PATHS = {
  CAMPAIGN_EDIT_SETTINGS: 'CAMPAIGN_EDIT_SETTINGS',
};

export const SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS = {
  AD_GROUP_SETTINGS: 'AD_GROUP_SETTINGS',
  KEYWORDS: 'KEYWORDS',
  CREATE_AD: 'CREATE_AD',
  CREATE_DSA_AD: 'CREATE_DSA_AD',
  BID_AND_TARGET: 'BID_AND_TARGET',
  BID_AND_TARGET_DSA: 'BID_AND_TARGET_DSA',
};

export const getAdGroupCreationStepListConfig = ({ i18n }) => [{
  id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.AD_GROUP_SETTINGS,
  title: i18n.getString(_TL_('Ad group')),
}, {
  id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.KEYWORDS,
  title: i18n.getString(_TL_('Keywords')),
}, {
  id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
  title: i18n.getString(_TL_('Create ads')),
}, {
  id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.CREATE_DSA_AD,
  title: i18n.getString(_TL_('Create ads')),
}, {
  id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET,
  title: i18n.getString(_TL_('Targets & bids')),
}, {
  id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET_DSA,
  title: i18n.getString(_TL_('Targets & bids')),
}];

export const SEARCH_AD_GROUP_EDIT_WIZARD_STEP_PATHS = {
  AD_GROUP_EDIT_SETTINGS: 'AD_GROUP_EDIT_SETTINGS',
};

export const AD_GROUP_TYPES = {
  SearchStandard: 'SearchStandard',
  SearchDynamic: 'SearchDynamic',
};

export const AD_GROUP_TYPE_STRINGS = {
  [AD_GROUP_TYPES.SearchStandard]: _TL_('Standard'),
  [AD_GROUP_TYPES.SearchDynamic]: _TL_('Dynamic'),
};

export const getSearchAdGroupCreationFlow = (flowFactors) => {
  const { adGroupType } = flowFactors;

  if (adGroupType === AD_GROUP_TYPES.SearchStandard) {
    return [
      SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.AD_GROUP_SETTINGS,
      SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.KEYWORDS,
      SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
      SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET,
    ];
  }

  return [
    SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.AD_GROUP_SETTINGS,
    SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.CREATE_DSA_AD,
    SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET_DSA,
  ];
};
